import IndexLayout from '../views/Layout/IndexLayout.vue'
// import EditCurtain from '../views/Pages/EditCurtain.vue'

// Base pages
const CurtainConfigurator = () =>
  import(/* webpackChunkName: "index" */ '../views/Pages/CurtainConfigurator')

  const EditCurtain = () =>
  import(/* webpackChunkName: "index" */ '../views/Pages/EditCurtain')

const routes = [
  {
    path: '/',
    component: IndexLayout,
    name: 'index',
    redirect: 'curtain-configurator',
    children: [
      {
        path: 'curtain-configurator',
        name: 'curtain-configurator',
        component: CurtainConfigurator,
      },
      {
        path: 'edit-curtain/:articleOrderId',
        name: 'edit-curtain',
        props: true,
        component: EditCurtain,
      },
    ],
  },
  { path: '*', redirect: '/curtain-configurator' },
]

export default routes
